export enum RouteStatus {
  Live = "live",
  Planning = "planning",
  Planned = "planned",
  Ended = "ended",
  Berm = "berm",
}
